import { TimeRangeEnum } from '@libs/backend-common';
import { CurrencyType, HistoryPeriodEnumKeys } from '@libs/types';
import { formatChartDate, getAlternativeAssetLabel } from 'src/helpers';
import { useTranslation } from 'src/hooks';
import {
  CoinDetailsCharts,
  CoinDetailsTabItem,
  CoinDetailsTabs,
} from '../constants/constants';

type ShortPeriodTabIds =
  | HistoryPeriodEnumKeys.ONE_DAY
  | HistoryPeriodEnumKeys.ONE_MONTH
  | HistoryPeriodEnumKeys.ONE_YEAR;
type ShortPeriodTabs = { title: string; id: ShortPeriodTabIds };

export const useCoinDetailsTabs = (assetCode: CurrencyType) => {
  const { t } = useTranslation();

  const coinDetailTabs: CoinDetailsTabItem[] = [
    {
      title: t('coin_details_tab_chart', {
        assetCode: getAlternativeAssetLabel(assetCode),
      }),
      id: CoinDetailsTabs.CHART,
    },
    {
      title: t('coin_details_tab_balance'),
      id: CoinDetailsTabs.BALANCE,
    },
    {
      title: t('coin_details_tab_dynamics'),
      id: CoinDetailsTabs.PRICE_DYNAMICS,
    },
    {
      title: t('coin_details_tab_statistics'),
      id: CoinDetailsTabs.STATISTICS,
    },
  ];
  const chartChangeTabs = [
    {
      title: t('coin_details_tab_price_chart'),
      id: CoinDetailsCharts.PRICE_CHART,
    },
    {
      title: t('common_market_cap_short'),
      id: CoinDetailsCharts.MARKET_CAP,
    },
  ];

  const shortPeriodTabs: ShortPeriodTabs[] = [
    {
      title: t('time_one_day'),
      id: HistoryPeriodEnumKeys.ONE_DAY,
    },
    {
      title: t('time_one_month'),
      id: HistoryPeriodEnumKeys.ONE_MONTH,
    },
    {
      title: t('time_one_year_full'),
      id: HistoryPeriodEnumKeys.ONE_YEAR,
    },
  ];

  const periodEnumValues = {
    [TimeRangeEnum.ONE_DAY]: {
      title: t('time_one_day'),
      dateFormat: 'h:mmA',
    },
    [TimeRangeEnum.ONE_WEEK]: {
      id: TimeRangeEnum.ONE_WEEK,
      title: t('time_one_week_full'),
      dateFormat: formatChartDate,
    },
    [TimeRangeEnum.ONE_MONTH]: {
      title: t('time_one_month'),
      dateFormat: formatChartDate,
    },
    [TimeRangeEnum.SIX_MONTHS]: {
      title: t('time_six_months'),
      dateFormat: formatChartDate,
    },
    [TimeRangeEnum.ONE_YEAR]: {
      title: t('time_one_year_full'),
      dateFormat: formatChartDate,
    },
  };

  const periodTabs = Object.entries(periodEnumValues).map(([key, value]) => ({
    id: key,
    title: value.title,
  }));

  return {
    periodTabs,
    chartChangeTabs,
    coinDetailTabs,
    shortPeriodTabs,
    periodEnumValues,
  };
};
